import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailedProductDescriptionComponent } from '../../../../core/components/detailed-product-description/detailed-product-description.component';
import {
  PostRequestBase,
  ResponseBase,
  RequestData,
  ScreenModel,
} from '../../../../core/models/common';
import {
  Product,
  ProductDetailDescription,
  ProductOption,
  ProductOptionServerData,
  ProductServerData,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { SideBarService } from '../../../../core/services/side-bar.service';
import {
  riskDeclaredLessThanRiskAssessed,
  riskDeclaredMoreThanRiskAssessed,
  riskDeclaredNotEqualRiskAssessed,
  
} from '../../../../core/utilities/riskAssessment';
import { SharedAPIService } from '../../../../core/services/shared-api.service';

// What we receive from the API when page is loaded
export interface NonRecommendedProductsData extends ResponseBase {
  TreasuryAdvisorName: string;
  NonRecommendedProductsOptions: ProductOptionServerData[];
  IsAcceptAssessedRiskProfile: boolean;
  DeclaredRiskProfile: string;
  AssessedRiskProfile: string;
  IsAcceptRecommendedProducts?: boolean;
  IsPurchaseTableBProducts?: boolean|null;
}

// What we will send to the API when submit
export interface NonRecommendedProductsRequestData extends PostRequestBase {
  NonRecommendedProductsOptions: ProductOptionServerData[];
}

// What we work with in this screen.
export class NonRecommendedProductsModel extends ScreenModel {
  screenName = 'NonRecommendedProducts';
  pageID_write = 'S0080';
  pageID_productDetails = 'R0080';
  data: NonRecommendedProductsData | undefined;
  treasuryAdvisorName: string | undefined;
  recommendedProducts: Product[] = [];
  nonRecommendedProductsOptions: ProductOption[] = [];
  recommendedProductsDetailDescription?: ProductDetailDescription;
  nonRecommendedProductsDetailDescription?: ProductDetailDescription;
  isAcceptAssessedRiskProfile: boolean | undefined;
  declaredRiskProfile: string | undefined;
  assessedRiskProfile: string | undefined;
  isAcceptRecommendedProducts?: boolean;
  isPurchaseTableBProducts?: boolean;
  sharedAPIService : any;
  recommendedProductsHolder : any;
  RecommendedProductsDetailDescriptionHolder:any;
  NonRecommendedProductsDetailDescriptionHolder:any;

  // Data lifecycle start.

  getLoadDataFromSession=()=>{
    return this.sharedAPIService.retrieveProductDetails();
  }
  mapPegaObjSavedToUI(data : any){
    let sample = this.sharedAPIService.getAcceptAssessedRiskProfile()
    let acceptProductsTableA = data['ProductDetails']['AcceptProductsInTableA']=='Yes'?true:data['ProductDetails']['AcceptProductsInTableA']=='No'?false:false;
    
    if(!this.sharedAPIService.getAcceptAssessedRiskProfile() && !acceptProductsTableA ){
      
      ['LowRisk','ModerateRisk','HighRisk'].forEach(riskLevel=>{
        this.savedData['ProductDetails']['TableA'][riskLevel].forEach((product:any)=>{
          product.pySelected = false;
        })
      })
    }
    data = this.savedData
    this.sharedAPIService.storeProductDetailsToSS(this.savedData)
    console.log("PRODUCTS PAGE+++++++")
    console.log(this.sharedAPIService.getTableABDesc())
    const tableADescList = this.sharedAPIService.getTableABDesc()['tableA']
    const tableBDescList = this.sharedAPIService.getTableABDesc()['tableB']
    this.recommendedProductsHolder = this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA'])
     
      let nonRecommendedProductsData:NonRecommendedProductsData  = {
        //RecommendedProducts: this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableA']),
        NonRecommendedProductsOptions : this.sharedAPIService.getProductsFromPegaTable(data['ProductDetails']['TableB']),
        IsAcceptRecommendedProducts: data['ProductDetails']['AcceptProductsInTableA']=='Yes'?true:data['ProductDetails']['AcceptProductsInTableA']=='No'?false:false,
        
        TreasuryAdvisorName: 'Treasuy X',

       
        IsAcceptAssessedRiskProfile: true,
        DeclaredRiskProfile: 'string',
        AssessedRiskProfile: 'string',
        IsPurchaseTableBProducts: data['ProductDetails']['PurchaseOtherProductsInTableB']=='Yes'?true:data['ProductDetails']['PurchaseOtherProductsInTableB']=='No'?false:null,
        
      }
     return nonRecommendedProductsData ;
   }

  deriveFromData(data: NonRecommendedProductsData) {
    
    this.treasuryAdvisorName = data.TreasuryAdvisorName;
    this.recommendedProducts = this.recommendedProductsHolder.map((product: ProductServerData) => {
      return {
        id: product.Id,
        riskLevel: product.RiskLevel,
        title: product.Title,
        description: product.Description,
      };
    });
    this.nonRecommendedProductsOptions = data.NonRecommendedProductsOptions.map((product) => {
      return {
        id: product.Id,
        riskLevel: product.RiskLevel,
        title: product.Title,
        description: product.Description,
        isChecked: (product.IsChecked === true)&&(!this.decideHide(product.RiskLevel,product.Description)),
        hide :this.decideHide(product.RiskLevel,product.Description)
      };
    });
    this.recommendedProductsDetailDescription =
      this.globals.model.recommendedProductsDetailDescription;
    this.nonRecommendedProductsDetailDescription =
      this.globals.model.nonRecommendedProductsDetailDescription;
    this.isAcceptRecommendedProducts = data.IsAcceptRecommendedProducts;
    console.log('deriveFromData, model:', this);
  }

  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): RequestData {
    // @For integration.

    this.nonRecommendedProductsOptions.forEach((product)=>{
      console.log("SAVENONRECOMENd")
     
      const prodRiskLevel = this.sharedAPIService.productCategoryMapReverse[product.riskLevel]
      console.log(prodRiskLevel)
      console.log(this.savedData)
      this.savedData['ProductDetails']['TableB'][prodRiskLevel].forEach((pegaProduct:any)=>{
        if(product.description == pegaProduct.ProductDescription){
          pegaProduct.pySelected = product.isChecked
        }
      })
      //this.savedData['ProductDetails']['TableB'][prodRiskLevel][product.id].pySelected = product.isChecked;
    })
    
   
    this.sharedAPIService.storeProductDetailsToSS(this.savedData)
    return {
      ServiceBody :this.savedData
    };
    // return {
    //   NonRecommendedProducts: this.nonRecommendedProducts.map((product) => {
    //     return {
    //       Id: product.id,
    //       RiskLevel: product.riskLevel,
    //       Title: product.title,
    //       Description: product.description,
    //       IsChecked: product.isChecked,
    //     };
    //   }),
    // };
  }


  decideHide(riskLevel:any,description:any){
    console.log(this.savedData)
    let hide = false
   
      this.recommendedProductsHolder.forEach((product:any)=>{
      
        if(description == product.Description && product.IsChecked ){
          
          hide = true;
         
        }
      })
 
    
    return hide
  }
  // Data lifecycle end.

  syncModelWithForm() {
    console.log('[NonRecommendedProductsModel] syncModelWithForm');
    let updatedNonRecommendedProducts: ProductOption[] = [];
    const formValues = this.form?.value;
    const riskLevelMap: { [key: string]: string } = {
      nonRecommendedLowRiskProducts: 'low',
      nonRecommendedModerateRiskProducts: 'moderate',
      nonRecommendedHighRiskProducts: 'high',
      nonRecommendedOtherProducts: 'others',
    };
    for (let key in formValues) {
      const riskLevel: string = riskLevelMap[key];
      updatedNonRecommendedProducts = updatedNonRecommendedProducts.concat(
        this.nonRecommendedProductsOptions
          .filter((product) => product.riskLevel == riskLevel)
          .map((product, index) => {
            return {
              ...product,
              isChecked: formValues[key][index],
            };
          }),
      );
    }
    this.nonRecommendedProductsOptions = updatedNonRecommendedProducts;
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-non-recommended-products',
  templateUrl: './non-recommended-products.component.html',
  styleUrls: ['./non-recommended-products.component.scss'],
})
export class NonRecommendedProductsComponent implements OnInit {
  model = new NonRecommendedProductsModel(
    this.globals,
    this.apiService,
    this.el,
  );

  form: FormGroup = this.formBuilder.group(
    {
      nonRecommendedLowRiskProducts: this.formBuilder.array(
        [],
        // this.minSelectedCheckboxes(1),
      ),
      nonRecommendedModerateRiskProducts: this.formBuilder.array([]),
      nonRecommendedHighRiskProducts: this.formBuilder.array([]),
      nonRecommendedOtherProducts: this.formBuilder.array([]),
    },
    { validators: this.minSelectedCheckboxes(1) },
  );

  seeAllRecommendedProduct = false;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private sideBarService: SideBarService,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.sharedAPIService = this.sharedAPIService
  }

  async ngOnInit() {
    console.log('[NonRecommendedProductsComponent] Page Onload');

    if(!this.sharedAPIService.retrieveProductDetails()){
      this.model.productDetailResponse = await this.model.callMiscService(this.model.pageID_productDetails,{})
      this.sharedAPIService.storeProductDetailsToSS(this.model.productDetailResponse)
 
      let tableADescList =  this.sharedAPIService.createTableAData(this.model.productDetailResponse.ProductDetails.TableA)
     let tableBDescList =  this.sharedAPIService.createTableAData(this.model.productDetailResponse.ProductDetails.TableB)
     this.sharedAPIService.setTableABDesc({
       tableA:tableADescList,
       tableB:tableBDescList
     }) 
    }
    await this.model.loadDataSaved();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    if (this.nonRecommendedLowRiskOption.length > 0) {
      this.nonRecommendedLowRiskOption.forEach((product) => {
        
        this.nonRecommendedLowRiskProductsFormArray.push(
          new FormControl(product.isChecked),
        );
      });
    }

    if (this.nonRecommendedModerateRiskOption.length > 0) {
      this.nonRecommendedModerateRiskOption.forEach((product) => {
        this.nonRecommendedModerateRiskProductsFormArray.push(
          new FormControl(product.isChecked),
        );
      });
    }

    if (this.nonRecommendedHighRiskOption.length > 0) {
      this.nonRecommendedHighRiskOption.forEach((product) => {
        this.nonRecommendedHighRiskProductsFormArray.push(
          new FormControl(product.isChecked),
        );
      });
    }

    if (this.nonRecommendedOthersOption.length > 0) {
      this.nonRecommendedOthersOption.forEach((product) => {
        this.nonRecommendedOtherProductsFormArray.push(
          new FormControl(product.isChecked),
        );
      });
    }
  };

  goToPreviousScreen = async () => {
    console.log('[NonRecommendedProductsComponent] goToPreviousScreen');
    if (this.sideBarService.showRecommendedProduct ) {//&& this.sharedAPIService.getAcceptAssessedRiskProfile()) {
      await this.router.navigateByUrl('/fna/recommended-products');
      return;
    }

    await this.router.navigateByUrl('/fna/risk-profile-assessment');
  };

  goToNextScreen = async () => {
    console.log('[NonRecommendedProductsComponent] goToNextScreen');
    await this.router.navigateByUrl('/fna/review-and-submit');
  };

  showRecommendedProduct() {
    const modalRef = this.modalService.open(
      DetailedProductDescriptionComponent,
      {
        modalDialogClass: 'fna-modal-dialog modal-fixed-height',
        scrollable: true,
      },
    );
    modalRef.componentInstance.title = 'Table A: Recommended products';

    modalRef.componentInstance.lowRiskContent =
      this.model.recommendedProductsDetailDescription?.lowRiskDescription;
    modalRef.componentInstance.moderateRiskContent =
      this.model.recommendedProductsDetailDescription?.moderateRiskDescription;
    modalRef.componentInstance.highRiskContent =
      this.model.recommendedProductsDetailDescription?.highRiskDescription;
  }

  showNonRecommendedProduct() {
    const modalRef = this.modalService.open(
      DetailedProductDescriptionComponent,
      {
        modalDialogClass: 'fna-modal-dialog modal-fixed-height',
        scrollable: true,
      },
    );
    modalRef.componentInstance.title = 'Table B: Non-recommended products';

    modalRef.componentInstance.lowRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.lowRiskDescription;
    modalRef.componentInstance.moderateRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.moderateRiskDescription;
    modalRef.componentInstance.highRiskContent =
      this.model.nonRecommendedProductsDetailDescription?.highRiskDescription;
  }

  minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formGroup: AbstractControl) => {
      let totalSelected = 0;
      const form = formGroup as FormGroup;
      for (let key in form.controls) {
        const formArray = form.controls[key];
        if (formArray instanceof FormArray) {
          const numberOfSelected = formArray.controls
            .map((control) => control.value)
            .reduce((prev, next) => (next ? prev + next : prev), 0);

          totalSelected += numberOfSelected;
        }
        if (totalSelected >= min) {
          return null;
        }
      }
      return { atLeastOneSelected: true };
    };

    return validator;
  }

  handleClickSeeAllRecommendedProduct() {
    this.seeAllRecommendedProduct = !this.seeAllRecommendedProduct;
  }

  // region Form controls
  get nonRecommendedLowRiskProductsFormArray() {
    return this.form.get('nonRecommendedLowRiskProducts') as FormArray;
  }
  get nonRecommendedModerateRiskProductsFormArray() {
    return this.form.get('nonRecommendedModerateRiskProducts') as FormArray;
  }
  get nonRecommendedHighRiskProductsFormArray() {
    return this.form.get('nonRecommendedHighRiskProducts') as FormArray;
  }
  get nonRecommendedOtherProductsFormArray() {
    return this.form.get('nonRecommendedOtherProducts') as FormArray;
  }

  // Form controls end region

  //region: getters

  get recommendedLowRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'low',
    );
  }
  get recommendedModerateRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'moderate',
    );
  }
  get recommendedHighRiskOption() {
    return this.model.recommendedProducts.filter(
      (product) => product.riskLevel === 'high',
    );
  }

  get nonRecommendedLowRiskOption() {
    return this.model.nonRecommendedProductsOptions.filter(
      (product) => product.riskLevel === 'low',
    );
  }
  get nonRecommendedModerateRiskOption() {
    return this.model.nonRecommendedProductsOptions.filter(
      (product) => product.riskLevel === 'moderate',
    );
  }
  get nonRecommendedHighRiskOption() {
    return this.model.nonRecommendedProductsOptions.filter(
      (product) => product.riskLevel === 'high',
    );
  }
  get nonRecommendedOthersOption() {
    return this.model.nonRecommendedProductsOptions.filter(
      (product) => product.riskLevel === 'others',
    );
  }

  //endregion
}
